import { ECalculateResultModalActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const closeCalculateResultModal = actionGenerator<ECalculateResultModalActionType.ModalClosed>(
  ECalculateResultModalActionType.ModalClosed,
);
